import React from 'react'

import Button from '@instabox/internal-web-ui/components/Button'
import { Link } from 'react-router-dom'

interface DeviceDetailsButtonProps {
  deviceId: string
}

const DeviceDetailsButton: React.FC<DeviceDetailsButtonProps> = ({ deviceId }) => {
  return (
    <Link to={`/device/${deviceId}`}>
      <Button variant="info" size="sm" shape="outlined">
        Details
      </Button>
    </Link>
  )
}

export default DeviceDetailsButton
